<template>
  <transition name="slide-fade" >
    <div  id="academicsHolder" >
      <div class="uk-child-width-1-1" uk-grid>
   <!--     <div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
          <div class="uk-container uk-container-small ">
            <p class="uk-text-center uk-text-lead@l uk-text-large@l">
              The physical of the holistic education we offer is as important as any other aspect.
            </p>
          </div>
        </div>-->

        <div class="uk-padding uk-background-muted uk-margin-remove-top">
          <h1 class="uk-heading-line uk-text-center specHeading"><span>Intercollegiate Sports</span></h1>
          <div class="uk-container uk-container-small ">
            <div class="uk-child-width-1-1@m" uk-grid>
              <div>
                <div class="uk-position-relative uk-visible-toggle uk-light" uk-slider="clsActivated: uk-transition-active; center: true; autoplay: true">

                  <ul class="uk-slider-items uk-grid">
                    <li class="uk-width-3-4">
                      <div class="uk-panel">
                        <img src="../assets/netball1.jpg" alt="">
                        <div class="uk-overlay uk-overlay-primary uk-position-bottom uk-text-center uk-transition-slide-bottom">
                          <h3 class="uk-margin-remove">Netball</h3>
                         <!-- <p class="uk-margin-remove">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>-->
                        </div>
                      </div>
                    </li>
                    <li class="uk-width-3-4">
                      <div class="uk-panel">
                        <img src="../assets/basketball1.jpg" alt="">
                        <div class="uk-overlay uk-overlay-primary uk-position-bottom uk-text-center uk-transition-slide-bottom">
                          <h3 class="uk-margin-remove">Basketball</h3>
                         <!-- <p class="uk-margin-remove">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>-->
                        </div>
                      </div>
                    </li>
                    <li class="uk-width-3-4">
                      <div class="uk-panel">
                        <img src="../assets/intercol2.jpg" alt="">
                        <div class="uk-overlay uk-overlay-primary uk-position-bottom uk-text-center uk-transition-slide-bottom">
                          <h3 class="uk-margin-remove">Football</h3>
                          <!--<p class="uk-margin-remove">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>-->
                        </div>
                      </div>
                    </li>
                    <li class="uk-width-3-4">
                      <div class="uk-panel">
                        <img src="../assets/badminton1.jpg" alt="">
                        <div class="uk-overlay uk-overlay-primary uk-position-bottom uk-text-center uk-transition-slide-bottom">
                          <h3 class="uk-margin-remove">Badminton</h3>
                         <!-- <p class="uk-margin-remove">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>-->
                        </div>
                      </div>
                    </li>
                    <li class="uk-width-3-4">
                      <div class="uk-panel">
                        <img src="../assets/cricket1.jpg" alt="">
                        <div class="uk-overlay uk-overlay-primary uk-position-bottom uk-text-center uk-transition-slide-bottom">
                          <h3 class="uk-margin-remove">Cricket</h3>
                          <!--<p class="uk-margin-remove">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>-->
                        </div>
                      </div>
                    </li>
                  </ul>

                  <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slider-item="previous"></a>
                  <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slider-item="next"></a>

                </div>
              </div>
              <div>
                <p class="">
                  <span class="uk-visible@m"><br></span>
                  Be a part of one of our most intriguing past times
                  on campus. This is a very important way to get involved on campus, it also serves as an
                  excellent means to learn different sporting activities while getting or keeping fit.
                  <br><br>
                  Even if you are off-field you can help us to forge an atmosphere that will push our Intercol teams
                  to continue to make Northern Caribbean University proud through sports.
                </p>

              </div>
            </div>
          </div>
        </div>

        <div class="uk-padding  uk-margin-remove-top">
          <h1 class="uk-heading-line uk-text-center specHeading">Sports to choose from</h1>
          <div class="uk-container uk-container-large ">
            <div class=" uk-child-width-1-2@s uk-child-width-1-3@m uk-child-width-1-5@l uk-child-width-1-6@xl" uk-grid>

              <div>
                <h3 class="uk-heading-bullet specHeading">Basketball</h3>
                <p class="uk-text-small uk-text-bold">
                  No. of Trophies: 1
                </p>
              </div>
              <div>
                <h3 class="uk-heading-bullet specHeading">Football</h3>
                <p class="uk-text-small uk-text-bold">
                  No. of Trophies: 1                </p>
              </div>
              <div>
                <h3 class="uk-heading-bullet specHeading">Cricket</h3>
                <p class="uk-text-small uk-text-bold">
                  No. of Trophies: 1                </p>
              </div>
              <div>
                <h3 class="uk-heading-bullet specHeading">Badminton</h3>
                <p class="uk-text-small uk-text-bold">
                  No. of Trophies: 1                </p>
              </div>
              <div>
                <h3 class="uk-heading-bullet specHeading">Netball</h3>
                <p class="uk-text-small uk-text-bold">
                  No. of Trophies: 1                </p>
              </div>
              <div>
                <h3 class="uk-heading-bullet specHeading">Volleyball</h3>
                <p class="uk-text-small uk-text-bold">
                  No. of Trophies: 1                </p>
              </div>

            </div>

          </div>
        </div>

        <div class="uk-padding uk-background-secondary uk-light uk-margin-remove-top">
          <h1 class="uk-heading-line uk-text-center specHeading">How to play intercol?</h1>
          <div class="uk-container uk-container-small ">
            <div class="uk-child-width-1-2@m" uk-grid>

              <div>
                <h3 class="uk-heading-bullet specHeading">What are the requirements to play</h3>
                <p class="uk-text-small">
                  To play intercol a student has to meet the following requirements:
                </p>

                <ul class="uk-list uk-list-bullet">
                  <li>Must be a currently registered student</li>
                  <li>Must maintain a proper school disciplinary record</li>
                  <li>Maintain a G.P.A of 2.5 or more</li>
                </ul>

              </div>
              <div class="uk-visible@m">
                <img src="../assets/req.png" alt="">

              </div>
            </div>

          </div>
        </div>



       <!-- <div class="uk-padding uk-background-muted uk-margin-remove-top">
          <h1 class="uk-heading-line uk-text-center specHeading">Intercol Calendar</h1>
          <div class="uk-container uk-container-large ">
            <div class="uk-child-width-1-1@m" uk-grid>
              <div class="uk-child-width-1-1">
                <div>
                  Intercol is played through out the year with different competition running at different times.
                </div>
                <h3 class="uk-heading-bullet uk-text-left specHeading">May</h3>
                <hr>
              </div>
              <div class="uk-child-width-1-1 uk-child-width-1-3@m uk-child-width-1-5@l uk-padding" uk-grid>
                <div>
                  <div uk-grid>
                    <div class="uk-width-auto@m">
                      <h3 class="uk-text-uppercase">7<span class="uk-text-small uk-text-muted">th</span></h3>
                    </div>
                    <div class="uk-width-expand@m">
                      Ending Date for final exams (Spring)
                    </div>
                  </div>
                </div>
                <div>
                  <div uk-grid>
                    <div class="uk-width-auto@m">
                      <h3 class="uk-text-uppercase">8<span class="uk-text-small uk-text-muted">th</span></h3>
                    </div>
                    <div class="uk-width-expand@m">
                      Ending Date for final exams (Spring)
                    </div>
                  </div>
                </div>
                <div>
                  <div uk-grid>
                    <div class="uk-width-auto@m">
                      <h3 class="uk-text-uppercase">9<span class="uk-text-small uk-text-muted">th</span></h3>
                    </div>
                    <div class="uk-width-expand@m">
                      Ending Date for final exams (Spring)
                    </div>
                  </div>
                </div>
                <div>
                  <div uk-grid>
                    <div class="uk-width-auto@m">
                      <h3 class="uk-text-uppercase">10<span class="uk-text-small uk-text-muted">th</span></h3>
                    </div>
                    <div class="uk-width-expand@m">
                      Ending Date for final exams (Spring)
                    </div>
                  </div>
                </div>
                <div>
                  <div uk-grid>
                    <div class="uk-width-auto@m">
                      <h3 class="uk-text-uppercase">11<span class="uk-text-small uk-text-muted">th</span></h3>
                    </div>
                    <div class="uk-width-expand@m">
                      Ending Date for final exams (Spring)
                    </div>
                  </div>
                </div>


              </div>
            </div>

          </div>
        </div>
-->
        <div class="uk-padding uk-background-muted uk-margin-remove-top">
          <h1 class="uk-heading-line uk-text-center specHeading">NCU Intercol Stories</h1>
          <div class="uk-container uk-container-small ">
            <div class="uk-child-width-1-2@m" uk-grid>
              <div>
                <img class="uk-align-center" src="../assets/intercol1.jpg" alt="">

              </div>
              <div>
                <h3 class="uk-heading-bullet specHeading"></h3>
                <!--<p class="">
                  Missed the action, don't worry read it and let your imagination take you back to the high and low points of each game.

                </p>-->
                <p class="">
                  Missed the action, don't worry view highlights  and let your imagination take you back to the high and low points of each game.

                </p>
                <div class="uk-align-center uk-align-right@l">
                  <br>
                  <!--<a href="#" class="uk-button uk-button-default">Read Stories</a>
                  <span class="uk-hidden@m"><br><br></span>-->
                  <a href="https://www.flickr.com/photos/72113266@N04/" target="_blank" class="uk-button uk-button-secondary">Latest Photos</a>


                </div>
              </div>

            </div>

          </div>
        </div>

        <div class="uk-padding uk-margin-remove-top">

          <div class="uk-container uk-container-small ">
            <div class="uk-child-width-1-2@s uk-grid-collapse " uk-grid>

            </div>

          </div>
        </div>


      </div>
    </div>
  </transition>
</template>

<script>
    export default {
        name: "intercolsports",
      mounted(){
        window.scrollTo(0, 0);
      },
      metaInfo: {
        // Children can override the title.
        title: 'NCU Intercol Sports',
        // Result: My Page Title ← My Site
        // If a child changes the title to "My Other Page Title",
        // it will become: My Other Page Title ← My Site
        //titleTemplate: '%s ← My Site',
        // Define meta tags here.
        meta: [
          {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
          {name: 'viewport', content: 'width=device-width, initial-scale=1'},
          {name: 'description', content: 'Intercol Sporting activities at Northern Caribbean University '}
        ]
      }
    }
</script>

<style scoped>
  @media screen and (max-width:600px){


    h3{
      font-size: 1.1em !important;
    }
    h1{
      font-size: 1.4em !important;
    }
    p,li{
      font-size: 0.8em !important;
    }


  }
</style>
